
class BankAccountMappingCell extends UITableViewCell
{
    private titleLabel: MUILabel = null;
    private ibanLabel: MUILabel = null;
    private mappingDropdown: MUIButton = null;

    awakeFromHTML() {
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
        this.ibanLabel = MUIOutlet(this, "iban-lbl", "MUILabel");

        this.mappingDropdown = MUIOutlet(this, "mapping-dd", "MUIButton");
        this.mappingDropdown.setAction(this, function(this:BankAccountMappingCell){
            AppHelper.sharedInstance().showSelectBankAccountTemplateViewControllerFromView(this.mappingDropdown, this, function(controller:SelectViewController, value:IntegratorMappingInfo){
                this._item.mappingInfo = value;
                this.mappingDropdown.title = value?.name;
            })
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item: BankAccount = null;
    set item(item: BankAccount) {
        this._item = item;
        this.titleLabel.text = item.info ? item.info.title : "";
        this.ibanLabel.text = item.info ? item.info.iban : "";
        this.mappingDropdown.title = item.mappingInfo?.name;
    }
}
